export default __webpack_public_path__ + "static/media/experiencesv3.8bccd2df.jpg";